import { Envs } from '@traba/types'

type Config = {
  FRONTEND_URL: string
  BUSINESS_APP_URL: string
}

function getConfigEnv(): Envs {
  if (process.env.NODE_ENV !== 'production') {
    return Envs.LOCAL
  }
  return import.meta.env.VITE_ENV
}

export const configEnv = getConfigEnv()

const configByEnv: Record<Envs, Config> = {
  [Envs.LOCAL]: {
    FRONTEND_URL: 'http://127.0.0.1:4203',
    BUSINESS_APP_URL: 'http://127.0.0.1:4200',
  },
  [Envs.DEVELOPMENT]: {
    FRONTEND_URL: 'https://devneo.traba.work',
    BUSINESS_APP_URL: 'https://devapp.traba.work',
  },
  [Envs.PRODUCTION]: {
    FRONTEND_URL: 'https://neo.traba.work',
    BUSINESS_APP_URL: 'https://app.traba.work',
  },
  [Envs.TEST]: {
    FRONTEND_URL: 'http://127.0.0.1:4203',
    BUSINESS_APP_URL: 'http://127.0.0.1:4200',
  },
}

export const config = configByEnv[configEnv]

export function isDebugEnv(queryParams: URLSearchParams): boolean {
  return (
    configEnv === Envs.DEVELOPMENT ||
    configEnv === Envs.LOCAL ||
    configEnv === Envs.TEST ||
    queryParams.get('debug') === 'true'
  )
}
